import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/** Shared light shell for legal pages — sticky TOC + long-form body. */
export default function LegalLayout({ eyebrow, title, updated, sections }) {
  return (
    <div className="min-h-screen bg-white text-[#0F1B2D]" data-testid="legal-page">
      <header className="border-b border-[#E6E2D8] bg-white/90 backdrop-blur-xl sticky top-0 z-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80" data-testid="legal-home-link">
            <img src="/prospera-icon.png" alt="" className="w-8 h-8 rounded-full" />
            <span className="font-display text-[#0B1F3F] text-lg">Prospera</span>
          </Link>
          <Link
            to="/"
            className="text-[#5A6476] hover:text-[#0B1F3F] text-sm inline-flex items-center gap-1.5"
            data-testid="legal-back-link"
          >
            <ChevronLeft size={15} /> Back to site
          </Link>
        </div>
      </header>

      <div className="bg-[#F7F5EF] border-b border-[#E6E2D8]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-14 md:py-20">
          <div className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[#8A6A2E]">
            {eyebrow}
          </div>
          <h1 className="font-display text-[#0B1F3F] text-4xl sm:text-5xl mt-4 leading-tight max-w-3xl" data-testid="legal-title">
            {title}
          </h1>
          {updated && <div className="text-[#5A6476] text-sm mt-4">Last updated: {updated}</div>}
        </div>
      </div>

      <main className="max-w-[1200px] mx-auto px-6 lg:px-12 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-12">
          <aside className="hidden lg:block sticky top-24 self-start">
            <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#5A6476] mb-4">
              On this page
            </div>
            <ul className="space-y-2.5 text-sm border-l border-[#E6E2D8]">
              {sections.map((s) => (
                <li key={s.id}>
                  <a
                    href={`#${s.id}`}
                    className="block pl-4 -ml-px border-l border-transparent text-[#5A6476] hover:text-[#0B1F3F] hover:border-[#B08D57] transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </aside>

          <div className="space-y-12 max-w-3xl">
            {sections.map((s) => (
              <section key={s.id} id={s.id} className="scroll-mt-24">
                <h2 className="font-display text-[#0B1F3F] text-2xl mb-4">{s.title}</h2>
                <div className="text-[#3D4656] text-[15px] leading-[1.8] space-y-4 [&_strong]:text-[#0B1F3F]">
                  {s.body}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>

      <footer className="border-t border-[#E6E2D8] py-8 mt-12 bg-[#F7F5EF]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-xs text-[#5A6476]">
          © {new Date().getFullYear()} Prospera Financial Inc. · Toronto, Ontario.
        </div>
      </footer>
    </div>
  );
}
